<template>
    <u-file-input-solo-rounded v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-file-input-solo-rounded>
</template>

<script>
import UFileInputSoloRounded from "@/components/publish/styles/forms/u-file-input-solo-rounded.vue";

export default {
    props: {},
    components: {
        UFileInputSoloRounded,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
